<template>
  <div>
    <ListContainer v-show="loadingCompleted" class="row mb-3" itemKey="no" :fetch="fetch" :filter="filter" :limit="limit" :emptyHint="emptyHint" :spinner="spinnerStyle">
      <template v-slot:list-item="{ item }">
        <div class="col-sm-12 col-md-6 col-lg-3 mb-3 mcf-gift-item">
          <RedeemItem class="bg-white border border-light rounded-md p-2 p-lg-3" :gift="item" @handleNonLogin="handleNonLogin" />
        </div>
      </template>
    </ListContainer>
    <Popup :isOpen.sync="popUp.isOpen" :mode="popUp.mode" :content="popUp.content" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { forkJoin } from 'rxjs';
import {
  map, filter, tap,
} from 'rxjs/operators';
import RedeemItem from '@/components/redeem/RedeemItem.vue';
import ListContainer from '@/components/ListContainer.vue';
import Popup from '@/components/Popup.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';
import sctService from '@/services/sctService';
import pdiService from '@/services/pdiService';

export default {
  components: {
    RedeemItem,
    ListContainer,
    Popup,
  },
  data() {
    return {
      // 讀取中spinner樣式
      spinnerStyle: '',
      // 最愛空白頁設定
      favoriteEmptyHint: {},
      // 搜尋空白頁設定
      searchEmptyHint: {},
      // popup設定
      popUp: {
        // 內容
        content: '',
        // 是否開啟
        isOpen: false,
      },
      // 資料是否完成載入
      loadingCompleted: false,
    };
  },
  computed: {
    ...mapState({
      itemDeptNoList: (state) => state.redeemItem.itemDeptNoList,
      favoriteItemNoList: (state) => state.redeemItem.favoriteItemNoList,
      keyword: (state) => state.redeemItem.keyword,
      limit: (state) => state.redeemItem.limit,
      activeType: (state) => state.redeemItem.activeType,
      orderType: (state) => state.redeemItem.orderType,
    }),

    // 列表資料篩選設定
    filter() {
      const vm = this;
      return {
        itemDeptNoList: vm.itemDeptNoList,
        favoriteItemNoList: vm.favoriteItemNoList,
        keyword: vm.keyword,
        activeType: vm.activeType,
        orderType: vm.orderType,
      };
    },
    // 是否登入
    hasLogged() {
      return !!this.$store.state.accessToken;
    },
    // 空白頁設定
    emptyHint() {
      const vm = this;
      if (vm.favoriteItemNoList.length > 0 && !vm.keyword) return vm.favoriteEmptyHint;
      return vm.searchEmptyHint;
    },
  },
  created() {
    const vm = this;

    // 取得頁面設定
    const getPageSetting = vm.$store.dispatch('getPageSetting', 'RedeemItem')
      .then((setting) => {
        // 空白頁設定
        vm.favoriteEmptyHint = {
          desc: pageSettingGetter.getFunctionWording(setting, 'FavoriteBlankPageWording'),
          img: pageSettingGetter.getFunction(setting, 'FavoriteBlankPagePic').picUrl,
          class: 'w-50 m-auto',
        };
        vm.searchEmptyHint = {
          desc: vm.$t('redeem.no-search-result'),
          img: pageSettingGetter.getFunction(setting, 'QueryNonResultPic').picUrl,
          class: 'w-50 m-auto',
        };
        // 樣式設定
        vm.spinnerStyle = setting.layoutType === '0' ? 'light' : 'secondary';
        // popUp設定(非登入)
        vm.popUp.content = pageSettingGetter.getFunctionWording(setting, 'FavoriteNonLogin');
        vm.popUp.mode = 'hint';
      });

    let getRedeemItemsCart = Promise.resolve([]);
    if (vm.hasLogged) {
      // 取得購物車列表
      const headers = { accessToken: vm.$store.state.accessToken };
      getRedeemItemsCart = sctService.getRedeemItemsCart(headers)
        .toPromise()
        .then((res) => {
          const carts = res.response.data;
          if (!carts.length) return;
          const itemNoList = carts.map((x) => x.no);
          const body = {
            companyId: vm.$store.state.companyId,
            deptNo: [],
            redeemItemNo: itemNoList,
            keyword: '',
            limit: carts.length,
            offset: 0,
            // 撈取上架中且前台可顯示
            activeType: 3,
            orderType: 0,
          };

          vm.$subscribeTo(pdiService.getRedeemItems(body).pipe(
            filter((response) => response.response.status === '200'),
            map((response) => response.response.data),
            tap((redeemItems) => {
              const cartList = redeemItems.map((x) => {
                const current = carts.find((y) => x.no === y.no);
                return {
                  no: current.no,
                  qty: current.qty,
                  point: x.point,
                };
              });

              vm.$store.commit('redeemItem/set', { name: 'cartList', value: cartList });
            }),
          ));
        });
    }

    Promise.all([getPageSetting, getRedeemItemsCart])
      .then(() => { vm.loadingCompleted = true; });
  },
  methods: {
    // 取得資料 observable
    fetch(pagination, filters) {
      const vm = this;
      const payload = {
        deptNo: filters.itemDeptNoList,
        redeemItemNo: filters.favoriteItemNoList,
        keyword: filters.keyword,
        limit: pagination.limit,
        offset: pagination.offset,
        activeType: filters.activeType,
        orderType: filters.orderType,
      };
      return forkJoin({
        list: vm.$store.dispatch('redeemItem/getRedeemItems', payload).then((res) => {
          if (res.response && res.response.data) { return res.response.data; }
          return [];
        }),
      });
    },
    // 處理非登入
    handleNonLogin() {
      this.popUp.isOpen = true;
    },
  },
};

</script>

<style>
@media (min-width: 960px) {
  .mcf-gift-item {
    margin-top: 0.25em;
  }
  .mcf-gift-item:hover>div {
    -webkit-box-shadow: 0 5px 0 0px rgb(0,0,0,0.15);
    -moz-box-shadow: 0 0 5px 0px rgb(0,0,0,0.15);
    box-shadow: 0 0 8px 0px rgb(0,0,0,0.15);
  }
  .mcf-gift-item > .border {
    border: 0 !important;
  }
}
</style>
